import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { HrmAccVoucherCode } from "../../models/hrm-acc-voucher-code.mode";
@Component({
  selector: "hrm-acc-voucher-code-form",
  templateUrl: "./hrm-acc-voucher-code-form.component.html",
  styleUrls: ["./hrm-acc-voucher-code-form.component.scss"],
})
export class HrmAccVoucherCodeFormComponent extends BaseFormComponent<HrmAccVoucherCode> {
  loadingIndicator: boolean;
  inputEditorform: any;
  DetailLedgerLevel: number = 0;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private missetup: MisSetupService) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.DetailLedgerLevel = this.missetup.getnumber("ACC", "DLLEVEL");
    this.apiName = "HrmAccVoucherCode";
    this.areaName = "Payroll";
    this.label = "ارتباط حسابها و عوامل";
    super.ngOnInit();
  }
  setColumnAttribute() {
    if (!this.DetailLedgerLevel) this.DetailLedgerLevel = this.missetup.getnumber("ACC", "DLLEVEL");
    this.orignalColumns.forEach((x) => {
      if (x.name.includes("DetailLedgerId") || x.name.includes("DetailLedgerKindId")) {
        x.formVisible = this.DetailLedgerLevel >= 1;
      }
      if (x.name.includes("DetailLedger2Id") || x.name.includes("DetailLedgerKind2Id")) {
        x.formVisible = this.DetailLedgerLevel >= 2;
      }
      if (x.name.includes("DetailLedger3Id") || x.name.includes("DetailLedgerKind3Id")) {
        x.formVisible = this.DetailLedgerLevel >= 3;
      }
      if (x.name.includes("DetailLedger4Id") || x.name.includes("DetailLedgerKind4Id")) {
        x.formVisible = this.DetailLedgerLevel >= 4;
      }
      if (x.name.includes("DetailLedger5Id") || x.name.includes("DetailLedgerKind5Id")) {
        x.formVisible = this.DetailLedgerLevel >= 5;
      }
    });
    this.columns = this.orignalColumns.filter((x) => x.formVisible);
    this.columns.forEach((x) => (x.userClass = "select-sm"));
    this.setColumnNumber(this.columns, 5);
  }
}
